import { render, staticRenderFns } from "./ArticleDirectoryModal__Style#Drawer.vue?vue&type=template&id=2522c619&scoped=true&"
import script from "./ArticleDirectoryModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./ArticleDirectoryModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDirectoryModal__Style#Drawer.vue?vue&type=style&index=0&id=2522c619&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2522c619",
  null
  
)

export default component.exports